module.exports = __webpack_public_path__ + "static/media/CE2.9cfe0399.jpg";